import { TrendingUp, Network, Landmark, Crosshair, Layers } from "lucide-react";
import { useContent } from "../../i18n/content";
import { SectionHeader } from "../SectionHeader";
import { Reveal } from "../motion/Reveal";

const ICONS = { TrendingUp, Network, Landmark, Crosshair, Layers };

export const WhySadja = () => {
    const { ui, site } = useContent();
    return (
    <section data-testid="why-sadja-section" className="relative py-24 lg:py-32">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
            <SectionHeader
                chapter={ui.why.chapter}
                overline={ui.why.overline}
                title={ui.why.title}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#4a4c42]">
                {site.whySadja.map((w, i) => {
                    const Icon = ICONS[w.icon];
                    return (
                        <Reveal key={w.num} delay={0.08 * i} className="h-full">
                            <div
                                data-testid={`why-card-${w.num}`}
                                className="group h-full bg-[#292a24] p-7 flex flex-col gap-6 hover:bg-[#32332c] transition-colors duration-500"
                            >
                                <div className="flex items-center justify-between">
                                    <Icon className="w-6 h-6 text-[#f6c422]" strokeWidth={1.5} />
                                    <span className="font-display text-xs text-[#a2a59d]/50 tracking-[0.2em]">{w.num}</span>
                                </div>
                                <h3 className="font-display text-base font-bold uppercase tracking-[0.1em] text-white leading-snug group-hover:text-[#f6c422] transition-colors duration-300">
                                    {w.title}
                                </h3>
                                <p className="text-sm text-[#a2a59d] leading-relaxed mt-auto">{w.desc}</p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
    );
};
